module.exports = "<router-outlet>\n  <toaster-container></toaster-container>\n</router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main